export default Object.freeze({
    lawnswood: {
        griefGuidance: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Grief%20and%20Loss%20Brochure_Lawnswood.pdf',
        bucketList: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Bucket%20List%20LW.pdf'
    },
    edenhills: {
        griefGuidance: {
            AW: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Grief%20and%20Loss%20Brochure_Edenhills%20AW.pdf',
            SA: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Grief%20and%20Loss%20Brochure_Edenhills%20Adelaide.pdf',
            VIC: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Grief%20and%20Loss%20Brochure_Edenhills%20VIC.pdf',
        },
        bucketList: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Bucket%20List%20EH.pdf'
    },
    nsw: {
        griefGuidance: {
            SW: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/Grief+and+Loss+Brochure_NSW+P%26P-SW.pdf',
            CW: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/Grief+and+Loss+Brochure_NSW+P%26P-CW.pdf',
            MO: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/Grief+and+Loss+Brochure_NSW+P%26P-MO.pdf',
        },
        bucketList: {
            SW: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/Bucket+List-NSW+P%26P-SW.pdf',
            CW: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/Bucket+List+PaP-NSW-P%26P-CW.pdf',
            MO: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/Bucket+List-NSW+P%26P-MO.pdf',
        },
    },
    qld: {
        griefGuidance: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/Grief+and+Loss+Brochure_Pets+In+Peace.pdf',
        bucketList: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/Bucket+List+PiP.pdf',
    }
});
